import React from 'react';
import { Link } from "react-router-dom"
import ApiFetch from "../components/ApiFetch"
import { Button, Container } from "react-bootstrap"
import UserMark from '../components/UserMark';

export function imgPath(type) {
    if(type === "image" || type === "video"){
        return ""
    } else {
        return "/" + type
    }
}
export function imageUrl(data,type){
    if(type === "video"){
        if(data.status >= 4){
            return ApiFetch.API_PROTOCOL+'//'+(type === "video" ? ApiFetch.VIDEO_HOST : ApiFetch.IMG_HOST) + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
        } else {
            return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/encode.webp'
        }
    } else {
        return ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST + imgPath(type) + '/post/t/'+(data.group_id)+"_in"+ApiFetch.API_THUMB_EXT
    }
}
export function arrayShuffle(array) {
    for(let i = (array.length - 1); 0 < i; i--){
  
      // 0〜(i+1)の範囲で値を取得
      let r = Math.floor(Math.random() * (i + 1));
  
      // 要素の並び替えを実行
      let tmp = array[i];
      array[i] = array[r];
      array[r] = tmp;
    }
    return array;
}
export function mousedragscrollable(element){
    if(element === null) return
    let target;
    const elms = document.querySelectorAll(element);
    for(let i=0; i<elms.length; i++){
      elms[i].addEventListener('mousedown', function(evt){
        //evt.preventDefault();
        target = elms[i];
        target.dataset.down = 'true';
        target.dataset.move = 'false';
        target.dataset.x = evt.clientX;
        target.dataset.y = evt.clientY;
        target.dataset.scrollleft = target.scrollLeft;
        target.dataset.scrolltop = target.scrollTop;
        evt.stopPropagation();
      });
      elms[i].addEventListener('click', function(evt){
        if(elms[i].detaset != null && elms[i].detaset.move == 'true') evt.stopPropagation();
      });
    }
    document.addEventListener('mousemove', function(evt){
      if(target != null && target.dataset.down == 'true'){
        evt.preventDefault();
        let move_x = parseInt(target.dataset.x) - evt.clientX;
        let move_y = parseInt(target.dataset.y) - evt.clientY;
        if (move_x !== 0 || move_y !== 0) {
          target.dataset.move = 'true';
        } else {
          return;
        }
        target.scrollLeft = parseInt(target.dataset.scrollleft) + move_x;
        target.scrollTop = parseInt(target.dataset.scrolltop) + move_y;
        evt.stopPropagation();
      }
    });
    document.addEventListener('mouseup', function(evt){
      if(target != null && target.dataset.down == 'true'){
        target.dataset.down = 'false';
        evt.stopPropagation();
      }
    });
}

export let zoomable = (element, options) => {
    let {minScale, maxScale, magnification} = {
        minScale: 0.1, 
        maxScale: 2, 
        magnification: -0.0025,
        ...options
    }
    if(element === null) return
    let img = element.querySelector("img")
    if(img === null) return
    let scale = 1
    //Math.min(img.naturalWidth,window.innerWidth * 0.8) / (window.innerWidth * 0.8)
    element.style.transform = "scale(1)"

    let zoomElement = (event) => {
        event.preventDefault() // Do not scroll the page

        const w1 = element.clientWidth
        const h1 = element.clientHeight

        // currently scale
        let s1 = Number(/(?<=\().*?(?=\))/.exec(element.style.transform))
        // gap with the parent element
        let gX = Number(/.*?(?=px)/.exec(element.style.left))
        let gY = Number(/.*?(?=px)/.exec(element.style.top))
        // center coordinate of the image
        let cX = w1/2 + gX
        let cY = h1/2 + gY
        // coordinate of the pointer
        let pX = event.pageX - element.parentElement.offsetLeft - window.scrollX
        let pY = event.pageY - element.parentElement.offsetTop - window.scrollY

        // distance between the center and the pointer
        let dX = pX - cX
        let dY = pY - cY

        // scale the image and move to correct coordinate
        scale += event.deltaY * magnification
        scale = Math.min(Math.max(minScale, scale), maxScale)
        element.style.left = gX + dX * (1 - scale/s1) + "px"
        element.style.top = gY + dY * (1 - scale/s1) + "px"
        element.style.transform = `scale(${scale})`
    };

    element.addEventListener("wheel", zoomElement)
}
export let moveable = (element) => {
    if(element === null) return
    element.style.position = "fixed";
    let img = element.querySelector("img")
    let x1 = Math.min((window.innerWidth - img.naturalWidth),window.innerWidth) / 2 + "px";
    let y1;
    let px1;
    let py1;
  
    let moveElement = (event) => {
      // Do not drag the image
      event.preventDefault();
      element.ondragstart = false; 
  
      element.style.left = x1 + event.pageX - px1 + "px";
      element.style.top = y1 + event.pageY - py1 + "px";
    };
  
    let mousedown = (event) => {
        x1 = Number(/.*?(?=px)/.exec(element.style.left))
        y1 = Number(/.*?(?=px)/.exec(element.style.top))
        px1 = event.pageX
        py1 = event.pageY
    
        element.addEventListener("mousemove", moveElement)
    }
    element.addEventListener("mousedown", mousedown)

    let mouseup = () => {
        element.removeEventListener("mousemove", moveElement)
    }

    element.addEventListener("mouseup", mouseup)
  }
export let resettable = (element,setEvents) => {
    if(element === null) return
    let resetElement = (event) => {
        if(event.key == " "){
            //event.preventDefault()
            let img = element.querySelector("img")
            let s
            if(window.innerWidth > window.innerHeight){
                s = window.innerHeight / Math.min(img.height,window.innerHeight) * 0.8
            } else {
                s = window.innerHeight / Math.min(img.height,window.innerHeight) * 0.8
            }
            element.style.transform = "scale("+s+")"
            element.style.left = Math.min(window.innerWidth - img.width,window.innerWidth) / 2 + "px"
            element.style.top = Math.min(window.innerHeight - img.height,window.innerHeight) / 2 + "px"
        }
    };

    document.body.addEventListener("keydown", resetElement)
    setEvents([{name:"keydown",elements:resetElement}])
  }

export function resetPosition(){
    let element = document.querySelector(".root")
    if(element === null) return
    element.querySelector("img").onload = (e) => {
        let img = e.currentTarget
        let s
        if(window.innerWidth > window.innerHeight){
            s = window.innerHeight / Math.min(img.height,window.innerHeight) * 0.8
        } else {
            s = window.innerHeight / Math.min(img.height,window.innerHeight) * 0.8
        }
        element.style.transform = "scale("+s+")"
        element.style.left = Math.min(window.innerWidth - img.width,window.innerWidth) / 2 + "px"
        element.style.top = Math.min(window.innerHeight - img.height,window.innerHeight) / 2 + "px"
    }
}

export function planDialog(dialog){
  dialog("料金プラン(運営への支援)",<div onClick={() => window.location.href = "/legal"} style={{cursor:"pointer"}}>
    いつもご利用ありがとうございます。<br />みなさんの支援によって、サービスを維持することができています。<br /><br />
  <span style={{color:"#555555",fontWeight:"bold",fontSize:"20px",borderBottom:"3px solid #555555"}}>ベーシック</span> <UserMark plan="basic" dialog={() => false} /> <span style={{backgroundColor:"#DDDDDD"}}>月額500円</span><br /><br />
  ・<b>広告非表示</b><br />
  ・画像を参考に生成<br /><br />

  <span style={{color:"#555555",fontWeight:"bold",fontSize:"20px",borderBottom:"3px solid #555555"}}>スタンダード</span> <UserMark plan="certification" dialog={() => false} /> <span style={{backgroundColor:"#DDDDDD"}}>月額1,400円</span><br /><br />
  ・<b>広告非表示</b><br />
  ・黄色認証マークの表示(要SMS認証)<br />
  ・画像生成機能の利用回数1日<b>100枚</b><br />
  ・生成画像のロゴ削除<br />
  ・生成履歴の保存期間：<b>7</b>日<br />
  ・生成した画像をzipでまとめてダウンロード：一度に最大<b>100</b>枚<br />
  ・直近1か月における画像作品の投稿枚数の上限：<b>350</b>枚<br />
  ・<b>優先して生成</b>：専用サーバーで処理されるため混雑が緩和されます。<br /><br />

  <span style={{color:"#555555",fontWeight:"bold",fontSize:"20px",borderBottom:"3px solid #555555"}}>プレミアム</span> <UserMark plan="unlimited" dialog={() => false} /> <span style={{backgroundColor:"#DDDDDD"}}>月額4,000円</span><br /><br />

  ・<b>広告非表示</b><br />
  ・黄色認証マークの表示(要SMS認証)<br />
  ・画像生成機能の利用回数1日<b>400枚</b><br />
  ・生成画像のロゴ削除<br />
  ・<b style={{color:"blue"}}>DALL-E3</b>の生成回数が1か月あたり<b>50枚</b><br />
  ・<b style={{color:"blue"}}>Stable Diffusion 3、Stable Image Ultra</b>の生成回数が1か月あたり<b style={{fontSize:"20px",color:"blue"}}>50枚</b><br />
  ・<b style={{color:"blue"}}>FLUX.1 schnell</b>の生成回数が1か月あたり<b style={{fontSize:"20px",color:"blue"}}>500枚</b><br />
  ・生成履歴の保存期間：<b>30</b>日<br />
  ・生成した画像をzipでまとめてダウンロード：一度に最大<b>300</b>枚<br />
  ・直近1か月における画像作品の投稿枚数の上限：<b>1000</b>枚<br />
  ・<b>優先して生成</b>：専用サーバーで処理されるため混雑が緩和されます。<br /><br />

  <span style={{color:"#555555",fontWeight:"bold",fontSize:"20px",borderBottom:"3px solid #555555"}}>プレミアムプラス</span> <UserMark plan="plus" dialog={() => false} /> <span style={{backgroundColor:"#DDDDDD"}}>月額20,000円</span><br /><br />

  ・<b>広告非表示</b><br />
  ・黄色認証マークの表示(要SMS認証)<br />
  ・画像生成機能の利用回数<b>無制限</b><br />
  ・生成画像のロゴ削除<br />
  ・<b style={{color:"blue"}}>DALL-E3</b>の生成回数が1か月あたり<b style={{fontSize:"20px",color:"blue"}}>500枚</b><br />
  ・<b style={{color:"blue"}}>Stable Diffusion 3、Stable Image Ultra</b>の生成回数が1か月あたり<b style={{fontSize:"20px",color:"blue"}}>500枚</b><br />
  ・<b style={{color:"blue"}}>FLUX.1 schnell</b>の生成回数が1か月あたり<b style={{fontSize:"20px",color:"blue"}}>5,000枚</b><br />
  ・生成履歴の保存期間：<b>30</b>日<br />
  ・生成した画像をzipでまとめてダウンロード：一度に最大<b>300</b>枚<br />
  ・直近1か月における画像作品の投稿枚数の上限：<b>1,000</b>枚<br />
  ・<b>優先して生成</b>：専用サーバーで処理されるため混雑が緩和されます。<br /><br />

  <Container className="text-center">
    <Button variant="warning" style={{padding:"14px",fontSize:"18px"}}>詳細</Button>
  </Container>
  </div>)
}